<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      基础信息
    </div>
    <div class="rj-page-card__content">
      <el-form ref="form" :model="formDataExt" class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                单据编号：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.orderNum }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请时间：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.applicantTime }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请人姓名：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.applicantName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请人所属部门：
              </div>
              <div class="rj-baseinfo__item">
                {{ formData.applicantDepartment }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                客户名称<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                {{ formDataExt.customerName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                客户编码<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="customerCode">
                  <el-checkbox-group v-model.trim="formDataExt.customerCode">
                    <el-checkbox v-for="(type,index) in codeOptions" :key="index" :label="type">
                      {{ type }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                签约类型：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="customerType">
                  {{ formDataExt.customerType }}
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                预计交易规模(万元)<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="proDealSize">
                  <el-input-number
                    v-model.trim="formDataExt.proDealSize"
                    :controls="false"
                    :precision="2"
                    :min="0"
                    placeholder="请输入文本"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                企业状态：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="enterpriseStatus">
                  <el-input v-model.trim="formDataExt.enterpriseStatus" maxlength="200" placeholder="请输入文本" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                注册资本(万元)<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="registeredCapital">
                  <el-input-number
                    v-model.trim="formDataExt.registeredCapital"
                    :controls="false"
                    :precision="2"
                    :min="0"
                    placeholder="请输入文本"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                注册资本币种<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="registeredCapitalCurrency">
                  <el-select v-model.trim="formDataExt.registeredCapitalCurrency" placeholder="请选择">
                    <el-option v-for="item in currencyList" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div v-if="formDataExt.registeredCapitalCurrency==='其他'" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__item">
                <el-input v-model.trim="formDataExt.otherRegisteredCapitalCurrency" maxlength="200" placeholder="请输入具体币种" />
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                实收注册资本币种<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="realRegisteredCapitalCurrency">
                  <el-select v-model.trim="formDataExt.realRegisteredCapitalCurrency" placeholder="请选择">
                    <el-option v-for="item in currencyList" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div v-if="formDataExt.realRegisteredCapitalCurrency==='其他'" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__item">
                <el-input v-model.trim="formDataExt.otherRealRegisteredCapitalCurrency" maxlength="200" placeholder="请输入具体币种" />
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                法人<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="legalPerson">
                  <el-input v-model.trim="formDataExt.legalPerson" maxlength="200" placeholder="请输入文本" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                法人类型：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="legalPersonType">
                  <el-input v-model.trim="formDataExt.legalPersonType" maxlength="200" placeholder="请输入文本" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                企业类型：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="enterpriseType">
                  <el-select v-model.trim="formDataExt.enterpriseType" placeholder="请选择">
                    <el-option v-for="item in enterpriseTypeList" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                成立日期<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="establishTime">
                  <el-date-picker
                    v-model.trim="formDataExt.establishTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择日期"
                    clearable
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否微小企业
                <el-tooltip class="item" content="小微企业概念来自工信部《中小企业划型标准规定》，具体标准根据企业从业人员、营业收入、资产总额等指标，结合行业特点制定。" placement="top">
                  <i style="color: #2589ff;" class="el-icon-warning" />
                </el-tooltip>
                ：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="tinyEnterpriseFlag">
                  <el-radio-group v-model.trim="formDataExt.tinyEnterpriseFlag">
                    <el-radio label="是">
                      是
                    </el-radio>
                    <el-radio label="否">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                人员规模：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="scale">
                  <el-select v-model.trim="formDataExt.scale" placeholder="请选择">
                    <el-option v-for="item in scaleList" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                企业评分：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="score">
                  <el-input v-model.trim="formDataExt.score" maxlength="200" placeholder="请输入文本" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                参保人数：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="personNum">
                  <el-input-number
                    v-model.trim="formDataExt.personNum"
                    :controls="false"
                    :precision="0"
                    :min="0"
                    placeholder="请输入文本"
                  />
                  人
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                统一社会信用代码<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="creditCode">
                  <el-input v-model.trim="formDataExt.creditCode" maxlength="200" placeholder="请输入文本" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                更新日期：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="establishUpdateTime">
                  <el-date-picker
                    v-model.trim="formDataExt.establishUpdateTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择日期"
                    clearable
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                注册地址<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="creditCode">
                  <el-input v-model.trim="formDataExt.address" maxlength="200" placeholder="请输入文本" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="businessRange" label="经营范围：">
              <el-input v-model.trim="formDataExt.businessRange" type="textarea" :rows="3" placeholder="请输入文本" maxlength="200" show-word-limit />
            </el-form-item>
          </div>
          <!-- <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                吊销日期：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="revokeTime">
                  <el-date-picker
                    v-model.trim="formDataExt.revokeTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择日期"
                    clearable
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                吊销原因：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="revokeReason">
                  <el-input v-model.trim="formDataExt.revokeReason" maxlength="200" placeholder="请输入吊销原因" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                注销日期：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="logoffTime">
                  <el-date-picker
                    v-model.trim="formDataExt.logoffTime"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="请选择日期"
                    clearable
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                注销原因：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="logoffReason">
                  <el-input v-model.trim="formDataExt.logoffReason" maxlength="200" placeholder="请输入注销原因" />
                </el-form-item>
              </div>
            </div>
          </div> -->
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请类型<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="applicantType">
                  <el-radio-group v-model.trim="formData.applicantType">
                    <el-radio :label="0">
                      固定额度
                    </el-radio>
                    <el-radio :label="1">
                      临时额度
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请类别<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="applicantCategory">
                  <el-select v-model.trim="formDataExt.applicantCategory" placeholder="请选择">
                    <el-option v-for="item in applicationType" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请额度(万元)<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="applicantLimit">
                  <el-input-number
                    v-model.trim="formDataExt.applicantLimit"
                    :controls="false"
                    :precision="0"
                    :min="0"
                    placeholder="请输入文本"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                申请账期<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="applicantPeriod">
                  <div style="display: flex;">
                    <el-input ref="readOnlyInput" v-model.trim="formDataExt.applicantPeriod" :read-only="true" placeholder="请输入文本" @focus="handleClick" />
                    <span class="span-box" @click="clickApplicantPeriod">&nbsp;&nbsp;填写账期</span>
                  </div>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否涉及定制化：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="customFlag">
                  <el-radio-group v-model.trim="formDataExt.customFlag">
                    <el-radio :label="1">
                      是
                    </el-radio>
                    <el-radio :label="0">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                付款方式<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="payType">
                  <el-checkbox-group v-model.trim="formDataExt.payType">
                    <el-checkbox v-for="(type,index) in salesTypeData" :key="index" :label="type.value">
                      {{ type.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__item">
                <el-input v-model.trim="formDataExt.otherPayType" maxlength="200" :disabled="!formDataExt.payType.includes('其他')" placeholder="请输入具体付款方式" />
              </div>
            </div>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="addMeasure">
              <template #label>
                增信措施<span class="required">*</span>：
              </template>
              <el-input v-model.trim="formDataExt.addMeasure" type="textarea" :rows="3" placeholder="主要包括：抵押、担保等" maxlength="200" show-word-limit />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="applicantReason">
              <template #label>
                申请理由<span class="required">*</span>：
              </template>
              <el-input
                v-model.trim="formDataExt.applicantReason"
                type="textarea"
                :rows="3"
                placeholder="请输入文本"
                maxlength="200"
                show-word-limit
              />
            </el-form-item>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                审批结果是否通知：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="customerCode">
                  <el-radio-group v-model="formDataExt.informFlag" @change="resultChange">
                    <el-radio v-for="(item, index) in isSendEmail" :key="index" :label="item.value">
                      {{ item.label }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <div v-if="formDataExt.informFlag === 1" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__item">
                <el-input
                  v-model.trim="formDataExt.email"
                  maxlength="200"
                  placeholder="请输入通知的邮箱"
                  @blur="validateEmail"
                />
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                锐捷商务<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="businessName">
                  <el-select
                    v-model.trim="formData.businessName"
                    placeholder="请选择"
                    filterable
                    remote
                    clearable
                    :remote-method="searchBussinessFunc"
                    @change="changeBussinessFunc()"
                  >
                    <el-option
                      v-for="item in businessList"
                      :key="item.userID"
                      :label="item.userName"
                      :value="item.userName"
                    />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <AccountPeriod ref="accountPeriod" @childEvent="handleChildEvent" />
  </div>
</template>
<script type="es6">
import { getEnterpriseBaseInfoAccurate, searchCustomer, getBusinessList } from '@/API/creditAxios.js';
import AccountPeriod from './accountPeriod.vue';
export default {
  data () {
    return {
      accountPeriod: null,
      readOnlyInput: null,
      customerList: undefined, // 客户下拉选
      businessList: [],
      codeOptions: [], // 客户编码选择框
      formData: {
        orderNum: '', // 单据编号
        applicantName: '', // 申请人姓名
        applicantTime: '', // 申请时间
        applicantDepartment: '', // 申请人所属部门
        applicant: '', // 申请人账号
        applicantDepartmentCode: '', // 申请人所属部门编码
        applicantType: '', // 申请类型
        deptDistrict: undefined, // 大区
        region: undefined, // 区域
        business: undefined, // 商务
        businessName: undefined // 商务名字
      },
      formDataExt: {
        customerName: '', // 客户名称
        customerType: '', // 客户类型
        enterpriseStatus: '', // 企业状态
        registeredCapitalCurrency: '', // 注册资本币种
        otherRegisteredCapitalCurrency: '', // 注册资本币种[其他]
        legalPerson: '', // 法人
        enterpriseType: '', // 企业类型
        tinyEnterpriseFlag: '', // 是否微小企业
        score: '', // 企业评分
        creditCode: '', // 统一社会信用代码
        customerCode: [], // 客户编码
        proDealSize: undefined, // 预计交易规模
        registeredCapital: '', // 注册资本
        realRegisteredCapitalCurrency: '', // 实收注册资本币种
        otherRealRegisteredCapitalCurrency: '', //  实收注册资本币种[其他]
        legalPersonType: '', // 法人类型
        establishTime: '', // 成立日期
        scale: undefined, // 人员规模
        personNum: undefined, // 参保人数
        establishUpdateTime: '', // 更新时间
        address: '', // 注册地址
        businessRange: '', // 经营范围
        revokeTime: '', // 吊销日期
        logoffTime: '', // 注销日期
        revokeReason: '', // 请输入吊销原因
        logoffReason: '', // 请输入注销原因
        applicantLimit: undefined, // 申请额度
        customFlag: 2, // 是否涉及定制化
        applicantCategory: null, // 申请类别
        applicantPeriod: '', // 申请账期
        payType: [], // 付款方式
        otherPayType: '', // 付款方式-其他
        addMeasure: '', // 增信措施，
        applicantReason: '', // 申请理由
        informFlag: 0, // 审批结果是否通知，0否，1是
        email: '' // 邮箱
      },
      loading: false,
      applicationType: [
        { code: '首次申请', value: '首次申请' },
        { code: '增加额度', value: '增加额度' },
        { code: '降低额度', value: '降低额度' },
        { code: '续额', value: '续额' },
        { code: '关闭', value: '关闭' },
        { code: '取消', value: '取消' }
      ],
      enterpriseTypeList: [
        {
          code: '有限责任公司',
          value: '有限责任公司'
        },
        {
          code: '有限责任公司分公司',
          value: '有限责任公司分公司'
        },
        {
          code: '股份有限公司',
          value: '股份有限公司'
        },
        {
          code: '个体工商户',
          value: '个体工商户'
        },
        {
          code: '其他',
          value: '其他'
        }
      ],
      scaleList: [
        {
          code: '小于50人',
          value: '小于50人'
        },
        {
          code: '50-99人',
          value: '50-99人'
        },
        {
          code: '100-499人',
          value: '100-499人'
        },
        {
          code: '500-999人',
          value: '500-999人'
        },
        {
          code: '1000-4999人',
          value: '1000-4999人'
        },
        {
          code: '5000人以上',
          value: '5000人以上'
        }
      ],
      currencyList: [
        {
          code: '人民币',
          value: '人民币'
        },
        {
          code: '美元',
          value: '美元'
        },
        {
          code: '港元',
          value: '港元'
        },
        {
          code: '其他',
          value: '其他'
        }
      ],
      salesTypeData: [
        { value: '电汇', label: '电汇' },
        { value: '银行承兑汇票', label: '银行承兑汇票' },
        { value: '其他', label: '其他' }
      ],
      isSendEmail: [
        { value: 1, label: '是' },
        { value: 0, label: '否' }
      ]
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
  },
  components: {
    AccountPeriod
  },
  computed: {

  },
  watch: {
    'formDataExt.payType': {
      handler (newData, oldData) {
        if (!newData.includes('其他')) {
          this.formDataExt.otherPayType = '';
        }
      },
      deep: true
    },
    'formDataExt.otherPayType': {
      handler (newData, oldData) {
        if (!this.formDataExt.payType.includes('其他')) {
          this.formDataExt.otherPayType = '';
        }
      },
      deep: true
    }
  },
  methods: {
    setData (params, paramsExt) {
      Object.assign(this.formData, params);
      Object.assign(this.formDataExt, paramsExt);
      this.formDataExt.customerCode = paramsExt.customerCode ? paramsExt.customerCode.split(',') : [];
      this.formDataExt.payType = paramsExt.payType ? paramsExt.payType.split(',') : [];
      this.getCustomerData();
    },
    handleClick () {
      this.$refs.readOnlyInput.blur(); // 点击输入框时先让输入框失焦
      this.clickApplicantPeriod(); // 调用相应的函数
    },
    // 回显账期
    handleChildEvent (val) {
      this.formDataExt.applicantPeriod = val;
    },
    // 填写账期
    clickApplicantPeriod () {
      this.$refs.accountPeriod.openDialog(this.formDataExt.applicantPeriod);
    },
    createGetData (data) {
      this.formData.orderNum = data.orderNum;
      this.formData.applicantName = data.applicantName;
      this.formData.applicantTime = data.createTime;
      this.formData.applicantDepartment = data.deptName;
      this.formData.applicant = data.applicant;
      this.formData.applicantDepartmentCode = data.deptCode;
      this.formDataExt.customerName = this.$store.state.user.userName;
      this.getCustomerData();
    },
    // 获取客户数据
    async getCustomerData () {
      try {
        let params = {
          name: this.formDataExt.customerName
        };
        const { data } = await getEnterpriseBaseInfoAccurate(params);
        if (data.status === '200') {
          this.codeOptions = data.data[0].agentId ? data.data[0].agentId.split(',') : [];
          this.formDataExt.legalPerson = data.data[0].legalPerson;
          this.formDataExt.creditCode = data.data[0].creditCode;
          this.formDataExt.registeredCapital = data.data[0].registerCaptial;
          this.formDataExt.establishTime = data.data[0].customerCreateTime;
          this.formDataExt.address = data.data[0].customerRegisterAddress;
          this.formDataExt.enterpriseStatus = data.data[0].customerStatus;
          this.formDataExt.customerType = data.data[0].partnerType.join('、');
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 获取客户下拉数据
    getSelectCustomer (val) {
      setTimeout(async () => {
        searchCustomer(val).then(res => {
          const { data, status } = res.data;
          if (status === '200') {
            this.customerList = data || [];
          } else {
          }
        });
      }, 500);
    },
    // 搜索锐捷商务
    async searchBussinessFunc (value) {
      try {
        const { data } = await getBusinessList(value);
        if (data.status === '200') {
          this.businessList = data.data || [];
        } else {
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 商务选择
    changeBussinessFunc () {
      if (this.formData.businessName) {
        const index = this.businessList.findIndex(item => item.userName === this.formData.businessName);
        if (index > -1) {
          this.formData.business = this.businessList[index].userID;
        } else {
          this.formData.business = undefined;
        }
      } else {
        this.formData.business = undefined;
      }
    },
    validateEmail () {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(this.formDataExt.email)) {
        this.$message.warning('请输入正确的邮箱地址');
      }
    },
    // 是否通知
    resultChange (value) {
      this.formDataExt.email = '';
    }
  },
  mounted () {
  }
};
</script>
<style lang="scss">
  .baseInfoForm {
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }
</style>
<style lang="scss">
  .baseInfoForm{
    .el-form-item__error{
      position: relative;
    }
  }
  .required{
    color: red;
    margin-left: 3px;
  }
  .span-box{
    color: rgba(37, 137, 255, 1);
    width: 100px;
    cursor: pointer;
  }
</style>
